import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import credit from '../layout/images/credit.png';
import invoice from '../layout/images/invoice.png';
import Typography from '@material-ui/core/Typography/Typography';

const styles = {
  container: {
    borderRadius: 2,
    border: '1px solid rgba(178,178,178,0.5)',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 130,
    justifyContent: 'center',
    alignItems: 'center',

    '&&:hover': {
      cursor: 'pointer',
    },
    '&& > img': {
      marginBottom: 11,
    },
    '&& > p': {
      color: '#212322',
      fontSize: 12,
      fontWeight: 500,
    },
  },
  checked: {
    borderColor: '#FF9200',
  },

};

export const PaymentMethod = ({ classes, checked, onClick, type, ...props }) => <button
  className={`${classes.container} ${checked ? classes.checked : null}`} onClick={onClick}>
  {

  }
  <img src={type === 'card' ? credit : invoice}/>
  <Typography>{type === 'card' ? 'Credit card' : 'Invoice'}</Typography>
</button>;

export default withStyles(styles)(PaymentMethod);
